import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import FirebaseContext from "../firebase/firebaseContext";
import StudentTeacher from "./StudentTeacher";

const Students = () => {
  const [grade, setGrade] = useState();
  const firebaseContext = useContext(FirebaseContext);
  const { db } = firebaseContext;
  const [homework, setHomework] = useState(null);
  const onSubmit = (e) => {
    e.preventDefault();
    filterList(grade);
  };

  const filterList = (newGrade) => {
    const homeworks = db.collection("students");
    homeworks.where("class", "==", newGrade).onSnapshot((snapshot) => {
      if (!snapshot) {
        setHomework((l) => []);
      } else {
        let homeworkList = [];
        snapshot.forEach((hw) => {
          homeworkList.push({ ...hw.data() });
        });
        setHomework((l) => homeworkList);
      }
    });
  };

  let homeworkToDisplay;
  if (homework === null) {
    homeworkToDisplay = (
      <div className='select-container'>
        <h1 className='heading-error'>Učenec še ni prijavljen.</h1>
      </div>
    );
  } else if (homework.length === 0) {
    homeworkToDisplay = (
      <div className='select-container'>
        <h1 className='heading-error'>
          V tem razredu ni prijavljenih učencev.
        </h1>
      </div>
    );
  } else {
    homeworkToDisplay = homework.map((hw) => {
      return (
        <div className='students-list'>
          <Link
            to={{
              pathname: "/ucenci/teacher/" + hw.id,
              state: hw,
            }}
          >
            <p style={{ color: "black", fontSize: "2rem" }}>{hw.name}</p>

            {hw.task === true ? (
              <li className='circle-student-green'></li>
            ) : (
              <li className='circle-student-red'></li>
            )}
          </Link>
        </div>
      );
    });
  }

  return (
    <section className='event-list'>
      <div>
        <div className='naloge-title'>
          <h1>Izberi razred in klikni "Potrdi"</h1>
        </div>
        <div className='naloge-container'>
          <div className='select-container'>
            <form onSubmit={(e) => onSubmit(e)}>
              <select
                value={grade}
                onChange={(e) => {
                  setGrade(e.target.value);
                }}
              >
                <option value='0. razred'>Izberi razred</option>

                <option value='6a'>6.a razred</option>
                <option value='6b'>6.b razred</option>

                <option value='7a'>7.a razred</option>
                <option value='7b'>7.b razred</option>

                <option value='8k'>8. razred - Kerstein</option>
                <option value='8u'>8. razred - Uršič</option>
                <option value='8s'>8. razred - Stanko</option>

                <option value='9k'>9. razred - Kerstein</option>
                <option value='9u'>9. razred - Uršič</option>
                <option value='9s'>9. razred - Stanko</option>
              </select>
              {!grade ? (
                <button type='submit' disabled>
                  Potrdi
                </button>
              ) : (
                <button type='submit'>Potrdi</button>
              )}
            </form>
          </div>
        </div>
        <div>{homeworkToDisplay}</div>
      </div>
    </section>
  );
};

export default Students;
